import { Box, Center, Circle, Flex, Wrap, Text } from '@rockr/rock-ui'
import React from 'react'
import styled from 'styled-components'

const DivStepper = styled.div`
position: relative;
width: 100%;
background: #fff;
padding: 15px 15px 40px;
`

type Props = {
  steps: any[],
  currentStep: string
}


export const Stepper: React.FC<Props> = (props) => {
  const {
    steps,
    currentStep
  } = props

  return (
    <DivStepper>
      <Wrap spacing="30px" justify="center">
        { steps.map((step, idx) => {
          let color = '#9BA5B3'
          let backgroundColor = '#fff'
          let border = '2px solid #9BA5B3'
          if(currentStep === step.id) {
            backgroundColor = '#225ED8'
            border = ''
            color = '#fff'
          }
          return (
            <Flex paddingX={10} key={idx}>
              <Circle size="32px" bg={backgroundColor} border={border} marginRight={14}>
                <Text color={color} fontSize="sm" as="b">
                  { idx + 1 }
                </Text>
              </Circle>
              <Box>
                <Center h="100%">
                  <Text color="gray.600" fontSize="sm" as="b">
                    { step.actionLabel }
                  </Text>
                </Center>
              </Box>
            </Flex>
          )
        }) }
      </Wrap>
    </DivStepper>
  )
}
